
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-impact",
      function () {
        return require("private-next-pages/social-impact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-impact"])
      });
    }
  